export default class RippleWindow {
	#value = 0;
	#maxValue = 0;

	constructor(ctx, effect) {
		const _ = this;
		_.ctx = ctx;
		_.effect = effect;
	}

	init() {
		this.reInit();
	}

	reInit() {
		const _ = this;
		_.options = _.ctx.store.getOptions();
		const widths = _.ctx.store.getWidths();

		// locally cache some values
		_.viewportWidth = widths.viewport;
		_.gapWidth = widths.gap;
		_.slideWidth = widths.slide;
		_.slideAndGapWidth = widths.slideAndGap;

		// calculate track start position
		_.trackStartPos = widths.paddingLeft;

		// we stop tracking after end position
		_.trackEndPos = widths.viewport - widths.track + widths.gap - widths.paddingRight;
	}

	setMaxValue(maxValue) {
		this.#maxValue = maxValue;
	}

	addAmount(trackDelta, trackPos = 0) {
		const _ = this;

		// if we aren't looping
		if (!_.options.loop) {
			// track start of track reached
			if (trackPos > _.trackStartPos) return;
			// end of track reached
			if (trackPos < _.trackEndPos) return;
		}

		// not looping & transitiong back to first slide
		if (!_.options.loop && trackDelta > 0 && trackPos > -1 * _.slideWidth) {
			// subtract trackDelta to value
			_.#value -= trackDelta;

			// not looping & transitioning to last slide
		} else if (!_.options.loop && trackDelta < 0 && trackPos < _.trackEndPos + _.slideAndGapWidth) {
			_.#value -= trackDelta;

			// default - add trackDelta to value
		} else {
			_.#value += trackDelta;
		}

		// make sure we stay within bounds
		if (_.#value < 0) {
			_.#value = 0;
		} else if (_.#value > _.#maxValue) {
			_.#value = _.#maxValue;
		}

		return _.#value;
	}

	getPercent() {
		return this.#maxValue > 0 ? this.#value / this.#maxValue : 0;
	}

	snapToValue(trackDelta, trackPos) {
		const _ = this;

		// exit if already at 0 or max values
		if (_.#value === 0 || _.#value === _.#maxValue) return;

		const addSettleAmount = Math.abs(trackDelta) * 1.25;

		if (_.#value > _.#maxValue / 2) {
			_.addAmount(addSettleAmount, trackPos);
		} else {
			_.addAmount(-addSettleAmount, trackPos);
		}
	}

	destroy() {
		const _ = this;

		// clear all references for garbage collection
		_.ctx = null;
		_.effect = null;
		_.handlers = null;
	}
}
